﻿import React from 'react';
import { ProductName } from '../productContent/productName';
import { ProductPrice } from '../productContent/productPrice';
import { ProductImage } from '../productContent/productImage';
import { ProductAvailability } from '../productContent/productAvailability';
import { Button } from 'wbm-inputs';
import { SearchResult } from '../../interfaces/searchResult';
import AddShoppingCartIcon from '@material-ui/icons/AddShoppingCart';
import { DropdownListView } from '../productObjects/DropdownListView';

type ProductAvailabilityType = {
    alertLevel: number,
    calloutMessage: string,
    deliveryMessage: string,
    estimatedDeliveryDate: string,
    estimatedDeliveryDateEndRange: string,
    itemId: string,
    requiresMessageDescriptions: boolean,
    stockMessage: string,
    unitId: string,
    wbTruckDelivery: boolean,
    doPreventAddToCart: boolean,
    preventPurchaseMessage: string
}

export interface IMerchandiseSliderItemProps {
    displayBackground: boolean,
    displayAddToCart: boolean,
    productInfo: SearchResult,
    productDetailsUrl?: string,
    listItems: any,
    dropdownSelectedItem: Function,
    cartImageOnClick: Function,
    displayShopButton?: boolean
    availabilityInfo?: ProductAvailabilityType;
}

const imageProps = {
    width: 180,
    height: 180
}

export const MerchandiseSliderItem = ({ ...props }: IMerchandiseSliderItemProps) => {

    return (
        <div className={props.displayBackground ? "merchandise-slider-item" : "merchandise-slider-item-no-background"}>
            <div className="row no-gutters">
                <div className="col-auto">
                    <div className="row no-gutters">
                        <div className="col-auto">
                            <div className="badge badge-pill badge-danger">

                            </div>
                            <div className="product-image mx-auto">
                                <a href={props.productDetailsUrl}>
                                    <ProductImage
                                        imgUrl={props.productInfo.imageUrl}
                                        className="image-container"
                                        altText={props.productInfo.itemId}
                                        width={imageProps.width}
                                        height={imageProps.height}
                                    />
                                </a>
                            </div>
                        </div>
                    </div>
                    <div className="row no-gutters merch-item-row">
                        <div className="col-auto merch-item-product-name">
                            <ProductName brandName={props.productInfo.brandName}
                                description={props.productInfo.description}
                                itemIdentifier={props.productInfo.itemIdentifier}
                                productHREF={props.productDetailsUrl}
                                displayId={props.productInfo.itemId}
                                textBold={false}
                            />
                        </div>
                    </div>
                    <div className="row no-gutters merch-item-row">
                        <div className="col-auto">
                            <ProductPrice
                                unitId={props.productInfo.unitId}
                                unitPrice={props.productInfo.unitPrice}
                            />
                        </div>
                    </div>
                    {props.displayAddToCart &&
                        <div className="row no-gutters merch-item-row">
                            <div className="col">
                                <DropdownListView
                                    list={props.listItems}
                                    itemSelected={props.dropdownSelectedItem}
                                />
                            </div>
                            <div className="col">
                                <Button className="btn-outline-primary">
                                    <AddShoppingCartIcon /> ADD
                                </Button>
                            </div>
                        </div>
                    }
                    {props.availabilityInfo &&
                        <div className="row no-gutters availability-row">
                            <div className="col">
                                <ProductAvailability
                                    availabilityInfo={props.availabilityInfo}
                                    smallText={false}
                                />
                            </div>
                        </div>
                    }
                    {props.displayShopButton &&
                        <div className="row no-gutters merch-item-row">
                            <div className="col">
                                <a href={props.productDetailsUrl}>
                                    <Button className="wbm-button btn btn-outline-primary col-12">
                                        SHOP
                                    </Button>
                                </a>
                            </div>
                        </div>
                    }
                </div>
            </div>
        </div>
    )
};

export default MerchandiseSliderItem;



